export const HELP_CENTER_ROOT_ROUTE_PATH = "help";
export const HELP_CENTER_ROOT_ROUTE_NAME = "help-center-root";
export const HELP_CENTER_ROUTE_NAME = "help-center";
export const HELP_CENTER_ARTICLE_ROUTE_NAME = "help-center-article";
